import "@/App.css";
import { initBrandColor } from "@/lib/brand";

initBrandColor();
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import Empleados from "@/pages/Empleados";
import Turnos from "@/pages/Turnos";
import Horarios from "@/pages/Horarios";
import Asistencia from "@/pages/Asistencia";
import Planillas from "@/pages/Planillas";
import Prestamos from "@/pages/Prestamos";
import Comisiones from "@/pages/Comisiones";
import Solicitudes from "@/pages/Solicitudes";
import Documentos from "@/pages/Documentos";
import Notificaciones from "@/pages/Notificaciones";
import Reportes from "@/pages/Reportes";
import Configuracion from "@/pages/Configuracion";
import MiSuscripcion from "@/pages/MiSuscripcion";
import Manual from "@/pages/Manual";
import { CircleNotch } from "@phosphor-icons/react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center" data-testid="session-loading">
        <CircleNotch className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/manual" element={<Manual />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="empleados" element={<Empleados />} />
            <Route path="turnos" element={<Turnos />} />
            <Route path="horarios" element={<Horarios />} />
            <Route path="asistencia" element={<Asistencia />} />
            <Route path="planillas" element={<Planillas />} />
            <Route path="prestamos" element={<Prestamos />} />
            <Route path="comisiones" element={<Comisiones />} />
            <Route path="solicitudes" element={<Solicitudes />} />
            <Route path="documentos" element={<Documentos />} />
            <Route path="notificaciones" element={<Notificaciones />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="mi-suscripcion" element={<MiSuscripcion />} />
            <Route path="configuracion" element={<Configuracion />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="top-right" theme={theme} richColors closeButton />;
}

export default App;
